<template>
<v-card class="pa-3">
    <v-card-title>
        <h4 class="title">{{parent.first_name}} {{parent.last_name}}</h4>
        <v-spacer></v-spacer>
        <h6 class="subheading">System ID: {{ parent.id }}</h6>
    </v-card-title>

    <v-data-table :headers="headers" :items="parent.students" hide-actions style="margin-bottom: 2rem;">
        <template slot="items" slot-scope="props">
            <tr>
                <td>{{ props.item.first_name }}</td>
                <td>{{ props.item.last_name }}</td>
                <td class="text-xs-center">{{ props.item.grade }}</td>
            </tr>
        </template>
    </v-data-table>

    <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn color="blue white--text" small @click="close">Close</v-btn>
    </v-card-actions>

</v-card>
</template>

<script>
export default {
    props: ['parent', 'active'],
    data() {
        return {
            headers: [{
                    text: 'First Name',
                    align: 'left',
                    value: 'first_name',
                    width: '20%'
                },
                {
                    text: 'Last Name',
                    align: 'left',
                    value: 'last_name',
                    width: '20%'
                },
                {
                    text: 'Current Grade',
                    align: 'center',
                    value: 'grade',
                    width: '10%'
                },
            ]
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
